module.exports = __webpack_public_path__ + "static/media/feedbellie.ba5bbf46.png";